import { Typography } from '@curology/ui-components-web/react';
import { MediaCard } from '@curology/ui-components-web/react/Card/MediaCard';
import { MediaCardContent } from '@curology/ui-components-web/react/Card/MediaCard/MediaCardContent';
import React from 'react';

import MediaImageCarousel from '../mediaImageCarousel';

const ProductCarousel = () => {
  const images = [
    {
      alt: 'Deep Cleanse Rx product carousel image #1',
      url: 'https://images.ctfassets.net/mdcr7mahi0vp/1vPq4nxOcUtAKGUxPq7etj/c96862db638716ca91e726594ad6ae07/deep_cleanse_carousel_1.png',
    },
    {
      alt: 'Deep Cleanse Rx product carousel image #2',
      url: 'https://images.ctfassets.net/mdcr7mahi0vp/5mrGb9bnBQtVE2vp1SSubj/b0dd2c51bdb7799a1e6ca669728a4e08/deep_cleanse_carousel_2.png',
    },
    {
      alt: 'Deep Cleanse Rx product carousel image #3',
      url: 'https://images.ctfassets.net/mdcr7mahi0vp/1O6FNIiy9oaN0u6OeFpmyM/a25a8fe9ede33ddd06fedc158ff7c25b/deep_cleanse_carousel_3.png',
    },
    {
      alt: 'Deep Cleanse Rx product carousel image #4',
      url: 'https://images.ctfassets.net/mdcr7mahi0vp/1aj3KxDALkdSXObFadqpUm/48cf3b10ea60f538179177ab3f966301/deep_cleanse_carousel_4.png',
    },
  ];

  return (
    <MediaCard className="cur-my-4">
      <MediaCardContent
        image={
          <MediaImageCarousel
            aspectRatio="3:2"
            images={images}
            productName="Deep Cleanse"
          />
        }
      >
        <Typography size="body" className="cur-mb-2">
          Get Deep Cleanse<sup>Rx</sup>, a custom cleanser that’s
          dermatologist-designed to work harder than your standard,
          off-the-shelf face wash.
        </Typography>
      </MediaCardContent>
    </MediaCard>
  );
};

export default ProductCarousel;
